import { useCreateCompany } from 'hq/hooks/queryHooks/companies/use-create-company';
import { companyAlerts, useAlert } from 'shared/components/alerts';
import { useLocation, useNavigate } from 'react-router-dom';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { FormProvider, useForm } from 'react-hook-form';
import { FormEvent, useCallback } from 'react';
import { Header, LwButton, Page, Toolbox } from 'redesign';
import { useGetCertificateNames } from 'hq/components/views/accreditations/hooks/use-get-certificates-names';
import { HQCertificateWithFileUrl } from 'hq/services/accreditations-service.types';
import { CompanyForm, CompanyFormData } from './company-form';
import { companyDataPrepareForSubmit } from './utils';
import { RenderUnsettledUI } from '../../../../../../shared/components';
import { routes } from '../../../../../../Routes';
import { IconApproved, IconCancel } from '../../../../../../assets/img';
import { hqRoutes } from '../../../../../Routes';

export const CompanyCreate = () => {
  const certificatesQuery = useGetCertificateNames();

  if (certificatesQuery.status !== 'success') {
    return <RenderUnsettledUI data={certificatesQuery} />;
  }

  return <CompanyCreateImpl certificates={certificatesQuery.data} />;
};

const CompanyCreateImpl = ({ certificates }: { certificates: HQCertificateWithFileUrl[] }) => {
  const formMethods = useForm<CompanyFormData>({
    defaultValues: {
      offersTempWork: false,
      offersFreelanceWork: false,
      workCooldownMinutes: 0,
      receiptCertificates: [],
    },
  });

  const navigate = useNavigate();
  const generatePath = useHqRelativePath();
  const { alertSuccess, alertError } = useAlert();
  const createCompany = useCreateCompany();
  const { search: filterParams } = useLocation();

  const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    formMethods.handleSubmit((data) => {
      const processedData = companyDataPrepareForSubmit(data);
      createCompany.mutate(processedData, {
        onSuccess: () => {
          alertSuccess(companyAlerts.success.created);
          navigate(generatePath(hqRoutes.Companies) + filterParams);
        },
        onError: (e) => alertError(e),
      });
    })();
  }, []);

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit}>
        <Page
          header={<Header titleText="Nieuw bedrijf aanmaken" />}
          toolbox={
            <Toolbox>
              <LwButton
                type="submit"
                iconColorMode="stroke"
                color="primary"
                startIcon={<IconApproved />}
              >
                Bedrijf aanpassen
              </LwButton>
              <LwButton
                onClick={() => navigate(generatePath(routes.Companies) + filterParams)}
                iconColorMode="fill"
                color="secondary"
                startIcon={<IconCancel />}
              >
                Annuleer
              </LwButton>
            </Toolbox>
          }
        >
          <CompanyForm state="create" certificates={certificates} orts={undefined} />
        </Page>
      </form>
    </FormProvider>
  );
};
